import { axiosUtil as Api } from "../utils/axios";
import CONFIG from "../utils/config";

const defaultTime = 15000;


const endpoint = CONFIG.VUE_APP_SERVICE_CLASSROOM_PRIVATE
const endpointV2 = CONFIG.VUE_APP_SERVICE_CLASSROOM_PRIVATE_V2
const endpointV3 = CONFIG.VUE_APP_SERVICE_CLASSROOM_PRIVATE_V3
const endpointPublic = CONFIG.VUE_APP_SERVICE_CLASSROOM

export const Classroom = Object.freeze({
    // Main Classroom
    list: (
        perPage,
        page,
        search
    ) => search ? Api.get(endpoint + '/classroom?per_page=' + perPage + '&page=' + page + '&search=' + search) : Api.get(endpoint + '/classroom?per_page=' + perPage + '&page=' + page, {

        timeout: defaultTime
    }),
    detail: id => Api.get(endpoint + '/classroom/' + id, {

        timeout: defaultTime
    }),
    classroomMember: (
        id,
        perPage,
        page,
        search,
        isGraduated,
        graduatedDate,
        joinedDate,
        orderBy,
        sortBy,
    ) => {
        let classroomEndpoint = `${endpointV2}/classroom/${id}/user?per_page=${perPage}&page=${page || 1}`

        if (search) {
            classroomEndpoint += `&search=${search}`
        }

        if (isGraduated) {
            classroomEndpoint += `&is_graduated=${isGraduated}`

            if (isGraduated === 'true' && graduatedDate[0] && graduatedDate[1]) {
                classroomEndpoint += `&start_date_graduated=${graduatedDate[0]}&end_date_graduated=${graduatedDate[1]}`
            }
        }

        if (joinedDate[0] && joinedDate[1]) {
            classroomEndpoint += `&joined_start=${joinedDate[0]}&joined_end=${joinedDate[1]}`
        }

        if (orderBy && sortBy) {
            classroomEndpoint += `&order_by=${orderBy}&sort_by=${sortBy}`
        }

        return Api.get(classroomEndpoint)
    },
    addClassroom: payload => {
        const formData = new FormData()
        formData.append('name', payload.name)
        formData.append('code', payload.code)
        formData.append('slug', payload.slug)
        formData.append('thumbnail', payload.thumbnail)
        formData.append('icon', payload.icon)
        formData.append('header', payload.header)
        formData.append('category_id', payload.categoryId)
        formData.append('forum', payload.forum)
        formData.append('begin_forum', payload.beginForum)
        formData.append('end_forum', payload.endForum)
        formData.append('short_description', payload.shortDescription)
        formData.append('description', payload.description)
        formData.append('rating', payload.rating)
        formData.append('url_video', payload.urlVideo)
        formData.append('mobile_price', payload.mobilePrice)
        formData.append('rupiah_price', payload.rupiahPrice)
        formData.append('normal_price', payload.normalPrice)
        formData.append('min_purchase', payload.minPurchase)
        formData.append('min_discount', payload.minDiscount)
        formData.append('started_at', payload.startedAt)
        formData.append('whatsapp_link', payload.whatsappLink)
        formData.append('is_express', payload.isExpress)
        formData.append('is_front_page', payload.isFrontpage)
        formData.append('is_private', payload.isPrivate)
        formData.append('is_active', payload.isActive)
        formData.append('must_voucher', payload.mustVoucher)
        formData.append('is_must_subject', payload.mustSubject)
        formData.append('is_must_module', payload.mustModule)
        formData.append('is_must_webinar_record', payload.mustWebinarRecord)
        formData.append('is_must_webinar', payload.mustWebinar)
        formData.append('is_must_quiz', payload.mustQuiz)
        formData.append('is_must_exam', payload.mustExam)
        formData.append('is_must_submission', payload.mustSubmission)
        formData.append('must_subject_tab', payload.mustSubjectTab)
        formData.append('must_module_tab', payload.mustModuleTab)
        formData.append('must_webinar_tab', payload.mustWebinarTab)
        formData.append('must_quizzes_tab', payload.mustQuizzesTab)
        formData.append('must_submission_tab', payload.mustSubmissionTab)
        formData.append('description_mobile', payload.descriptionMobile)
        formData.append('can_pay_later', payload.canPaylater)
        formData.append('is_desc_mobile_html', payload.isDescMobileHtml)
        formData.append('description_mobile_html', payload.descriptionMobileHtml)
        formData.append('expired_at', payload.expiredAt)
        formData.append('is_webinar_private', payload.isWebinarPrivate)
        formData.append('is_certificate_disabled', !payload.isCertificate)


        // console.log(formData)

        const res = Api.post(endpoint + '/classroom', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            timeout: defaultTime
        })

        return Promise.resolve(res)
    },
    editClassroom: (classroomId, payload) => {
        const formData = new FormData()
        formData.append('name', payload.name)
        formData.append('code', payload.code)
        formData.append('slug', payload.slug)
        formData.append('thumbnail', payload.thumbnail)
        formData.append('icon', payload.icon)
        formData.append('header', payload.header)
        formData.append('category_id', payload.categoryId)
        formData.append('forum', payload.forum)
        formData.append('begin_forum', payload.beginForum)
        formData.append('end_forum', payload.endForum)
        formData.append('short_description', payload.shortDescription)
        formData.append('description', payload.description)
        formData.append('rating', payload.rating)
        formData.append('url_video', payload.urlVideo)
        formData.append('mobile_price', payload.mobilePrice)
        formData.append('normal_price', payload.normalPrice)
        formData.append('rupiah_price', payload.rupiahPrice)
        formData.append('min_purchase', payload.minPurchase)
        formData.append('min_discount', payload.minDiscount)
        formData.append('started_at', payload.startedAt)
        formData.append('whatsapp_link', payload.whatsappLink)
        formData.append('is_express', payload.isExpress)
        formData.append('is_front_page', payload.isFrontpage)
        formData.append('is_private', payload.isPrivate)
        formData.append('is_active', payload.isActive)
        formData.append('must_voucher', payload.mustVoucher)
        formData.append('is_must_subject', payload.mustSubject)
        formData.append('is_must_module', payload.mustModule)
        formData.append('is_must_webinar_record', payload.mustWebinarRecord)
        formData.append('is_must_webinar', payload.mustWebinar)
        formData.append('is_must_quiz', payload.mustQuiz)
        formData.append('is_must_exam', payload.mustExam)
        formData.append('is_must_submission', payload.mustSubmission)
        formData.append('must_subject_tab', payload.mustSubjectTab)
        formData.append('must_module_tab', payload.mustModuleTab)
        formData.append('must_webinar_tab', payload.mustWebinarTab)
        formData.append('must_quizzes_tab', payload.mustQuizzesTab)
        formData.append('must_submission_tab', payload.mustSubmissionTab)
        formData.append('description_mobile', payload.descriptionMobile)
        formData.append('can_pay_later', payload.canPaylater)
        formData.append('is_desc_mobile_html', payload.isDescMobileHtml)
        formData.append('description_mobile_html', payload.descriptionMobileHtml)
        formData.append('expired_at', payload.expiredAt)
        formData.append('is_webinar_private', payload.isWebinarPrivate)
        formData.append('is_certificate_disabled', !payload.isCertificate)

        const res = Api.put(endpoint + '/classroom/' + classroomId, formData)

        // console.log("data cek", res)

        return Promise.resolve(res)
    },
    classroomDelete: classroomId => {
        const res = Api.delete(endpoint + '/classroom/' + classroomId, {

            timeout: defaultTime
        })

        return Promise.resolve(res);
    },
    listAll: () => Api.get(endpoint + '/classroom?per_page=500'),
    classroomAllSimple: () => Api.get(endpoint + '/simple?per_page=500'),
    classroomAllSimpleActive: () => Api.get(endpoint + '/simple?per_page=500&is_active=true'),
    classroomSearch: (search) => Api.get(endpoint + '/classroom?per_page=100&search=' + search),
    // level
    levelAdd: payload => {
        const formData = new FormData()
        formData.append('name', payload.name)
        formData.append('code', payload.code)
        formData.append('classroom_id', payload.classroomID)
        formData.append('rupiah_price', payload.rupiahPrice)
        formData.append('coin_price', payload.coinPrice)
        formData.append('ordering', payload.ordering)

        formData.append('short_description', payload.shortDescription)
        formData.append('description', payload.description)
        formData.append('subscriber', payload.subscriber)
        formData.append('wholesale_price', payload.wholesalePrice)
        formData.append('rupiah_wholesale', payload.rupiahWholesale)
        formData.append('thumbnail', payload.thumbnail)
        formData.append('header', payload.header)




        // console.log('result', formData)

        const res = Api.post(endpoint + '/level', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            timeout: defaultTime
        })

        return Promise.resolve(res)
    },
    // Category
    categoryList: () => Api.get(endpoint + '/category?per_page=100'),
    categoryListSimple: () => Api.get(endpoint + '/simple-category?per_page=100'),
    categoryDetail: (id) => Api.get(endpoint + '/category/' + id),
    categoryAdd: (payload) => {

        const formData = new FormData()
        formData.append('name', payload.name)
        formData.append('slug', payload.slug)
        formData.append('thumbnail', payload.thumbnail)
        formData.append('short_description', payload.shortDescription)
        formData.append('description', payload.description)


        const res = Api.post(endpoint + '/category', formData, {

            timeout: defaultTime
        })

        return Promise.resolve(res)
    },
    categoryEdit: (categoryId, payload) => {

        // console.log(payload)
        const formData = new FormData()
        formData.append('name', payload.name)
        formData.append('slug', payload.slug)
        formData.append('thumbnail', payload.thumbnail)
        formData.append('short_description', payload.shortDescription)
        formData.append('description', payload.description)

        const res = Api.put(endpoint + '/category/' + categoryId, formData, {

            timeout: defaultTime
        })

        return Promise.resolve(res)
    },
    categoryDelete: (categoryId) => {
        const res = Api.delete(endpoint + '/category/' + categoryId, {

            timeout: defaultTime
        })

        return Promise.resolve(res)
    },
    // Video
    videoList: id => Api.get(endpoint + '/classroom/' + id + '/video?per_page=200', {

        timeout: defaultTime
    }),
    videoDetail: videoId => Api.get(endpoint + '/subject/' + videoId + '/show'),
    addVideo: (payload) => {
        // console.log('add payload', payload)
        const formData = new FormData()
        formData.append('title', payload.title)
        formData.append('slug', payload.slug)
        formData.append('classroom_id', payload.classroomId)
        formData.append('classroom_level_id', payload.classroomLevelId)
        formData.append('short_description', payload.shortDescription)
        formData.append('description', payload.description)
        formData.append('thumbnail', payload.thumbnail)
        formData.append('video', payload.video)
        formData.append('video_link', payload.link)
        formData.append('published_at', '"' + payload.publishedAt + '"')
        formData.append('duration', payload.duration)
        formData.append('ordering', payload.ordering)
        formData.append('status', payload.status)


        const res = Api.post(endpoint + '/subject', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })

        return Promise.resolve(res);
    },

    editVideo: (videoId, payload) => {

        const formData = new FormData()
        formData.append('title', payload.title)
        formData.append('slug', payload.slug)
        formData.append('classroom_id', payload.classroomId)
        formData.append('classroom_level_id', payload.classroomLevelId)
        formData.append('short_description', payload.shortDescription)
        formData.append('description', payload.description)
        formData.append('thumbnail', payload.thumbnail)
        formData.append('video', payload.video)
        formData.append('video_link', payload.link)
        formData.append('published_at', '"' + payload.publishedAt + '"')
        formData.append('duration', payload.duration)
        formData.append('ordering', payload.ordering)
        formData.append('status', payload.status)

        const res = Api.put(endpoint + '/subject/' + videoId, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                timeout: defaultTime
            })
            // console.log('resss', res)
        return Promise.resolve(res);
    },
    videoDelete: videoId => {
        const res = Api.delete(endpoint + '/subject/' + videoId, {

            timeout: defaultTime
        })

        return Promise.resolve(res);
    },
    // Webinar
    webinarList: (id, isExpired) => Api.get(endpoint + '/classroom/' + id + '/webinar?perpage=100&is_expired=' + isExpired, {
        timeout: defaultTime
    }),
    webinarDetail: webinarId => Api.get(endpoint + '/webinar/' + webinarId, {
        timeout: defaultTime
    }),
    webinarAdd: (payload) => {
        try {
            const res = Api.post(endpoint + '/webinar', payload, {
                timeout: defaultTime
            })
            return Promise.resolve(res);
        } catch (err) {
            return Promise.reject(err)
        }
    },
    webinarUpdate: (webinarId, payload) => {
        try {
            const res = Api.put(endpoint + '/webinar/' + webinarId, payload, {
                timeout: defaultTime
            })
            return Promise.resolve(res);
        } catch (err) {
            return Promise.reject(err)
        }
    },
    webinarAddWithThumbnail: (payload) => {
        try {
            const formData = new FormData()
            formData.append('name', payload.name)
            formData.append('link', payload.link)
            formData.append('started_at', payload.started_at)
            formData.append('expired_at', payload.expired_at)
            formData.append('classroom_level_id', payload.classroom_level_id)
            formData.append('is_active', payload.is_active)
            formData.append('can_request_plus', payload.can_request_plus)
            if(payload.room_id > 0) {
                formData.append('room_id', payload.room_id)
            }
            if(payload.can_request_plus) {
                formData.append('request_plus_started_at', payload.request_plus_started_at)
                formData.append('request_plus_expired_at', payload.request_plus_expired_at)
            }
            if(payload.thumbnail) {
                formData.append('thumbnail', payload.thumbnail)
            }
            const res = Api.post(endpointV2 + '/webinar', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                timeout: defaultTime
            })
            return Promise.resolve(res);
        } catch(err) {
            return Promise.reject(err)
        }
    },
    webinarUpdateWithThumbnail: (webinarId, payload) => {
        try {
            const formData = new FormData()
            formData.append('name', payload.name)
            formData.append('link', payload.link)
            formData.append('started_at', payload.started_at)
            formData.append('expired_at', payload.expired_at)
            formData.append('classroom_level_id', payload.classroom_level_id)
            formData.append('is_active', payload.is_active)
            formData.append('can_request_plus', payload.can_request_plus)
            if(payload.room_id > 0) {
                formData.append('room_id', payload.room_id)
            }
            if(payload.can_request_plus) {
                if(payload.request_plus_started_at && payload.request_plus_started_at != '0001-01-01 00:00:00') {
                    formData.append('request_plus_started_at', payload.request_plus_started_at)
                }
            
                if(payload.request_plus_expired_at && payload.request_plus_expired_at != '0001-01-01 00:00:00') {
                    formData.append('request_plus_expired_at', payload.request_plus_expired_at)
                }
            }
            if(payload.thumbnail) {
                formData.append('thumbnail', payload.thumbnail)
            }
            const res = Api.put(endpoint + '/webinar/' + webinarId + '/thumbnail', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                timeout: defaultTime
            })
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },
    webinarDelete: webinarId => {
        const res = Api.delete(endpoint + '/webinar/' + webinarId, {

            timeout: defaultTime
        })

        return Promise.resolve(res);
    },
    webinarParticipantList: (webinarId, start_date, end_date) => {
        let participantsList = endpoint +
            '/webinar/' +
            webinarId +
            '/participants?per_page=-1&page=1&start=' +
            start_date +
            '&end=' +
            end_date

        const res = Api.get(participantsList, {

            timeout: defaultTime
        })

        return Promise.resolve(res)
    },
    webinarParticipantListDownload: (webinarId, start_date, end_date) => {
        let participantsList = endpoint +
            '/webinar/' +
            webinarId +
            '/participants?is_download=true&per_page=-1&page=1&start=' +
            start_date +
            '&end=' +
            end_date

        const res = Api.get(participantsList, {
            responseType: 'blob',
            timeout: defaultTime
        })

        return Promise.resolve(res)
    },
    // Modul
    modulList: id => Api.get(endpoint + '/classroom/' + id + '/module-admin'),
    modulDetail: modulId => Api.get(endpoint + '/module/' + modulId),
    modulAdd: payload => {

        const formData = new FormData()
        formData.append('title', payload.title)
        formData.append('slug', payload.slug)
        formData.append('classroom_level_id', payload.classroomLevelId)
        formData.append('short_description', payload.shortDescription)
        formData.append('description', payload.description)
        formData.append('thumbnail', payload.thumbnail)
        formData.append('file', payload.file)
        formData.append('ordering', payload.ordering)


        const res = Api.post(endpoint + '/module', formData, {
            timeout: defaultTime
        })

        return Promise.resolve(res)
    },
    modulEdit: (modulId, payload) => {

        const formData = new FormData()
        formData.append('title', payload.title)
        formData.append('slug', payload.slug)
        formData.append('classroom_level_id', payload.classroomLevelId)
        formData.append('short_description', payload.shortDescription)
        formData.append('description', payload.description)
        formData.append('thumbnail', payload.thumbnail)
        formData.append('file', payload.file)
        formData.append('ordering', payload.ordering)

        const res = Api.put(endpoint + '/module/' + modulId, formData, {
            timeout: defaultTime
        })

        return Promise.resolve(res)
    },
    modulDelete: (modulId) => {
        const res = Api.delete(endpoint + '/module/' + modulId, {
            timeout: defaultTime
        })

        return Promise.resolve(res)
    },

    // Quiz
    quizList: id => Api.get(endpoint + '/quiz/' + id + '/classroom'),
    quizDetail: quizId => Api.get(endpoint + '/quiz/' + quizId),
    quizAdd: (payload) => {
        const res = Api.post(endpoint + '/quiz', payload, {
                timeout: defaultTime
            })
            // console.log(Promise.resolve(res))
        return Promise.resolve(res)
    },
    quizEdit: (quizId, payload) => {
        const res = Api.put(endpoint + '/quiz/' + quizId, payload, {
            timeout: defaultTime
        })
        return Promise.resolve(res)
    },
    quizDelete: (quizId) => {
        const res = Api.delete(endpoint + '/quiz/' + quizId, {
            timeout: defaultTime
        })
        return Promise.resolve(res)
    },
    quizQuestionList: quizId => Api.get(endpoint + '/quiz/' + quizId + '/items'),
    quizQuestionAdd: payload => {
        const res = Api.post(endpoint + '/quiz-item', payload, {
            timeout: defaultTime
        })

        return Promise.resolve(res)
    },
    quizQuestionEdit: (quizQuestion, payload) => {
        const res = Api.put(endpoint + '/quiz-item/' + quizQuestion, payload, {
            timeout: defaultTime
        })

        return Promise.resolve(res)
    },
    quizQuestionDelete: (quizQuestion) => {
        const res = Api.delete(endpoint + '/quiz-item/' + quizQuestion, {
            timeout: defaultTime
        })

        return Promise.resolve(res)
    },
    quizQuestionImport: (payload) => {
        try {
            const formData = new FormData()
            formData.append('file', payload.file)
            const res = Api.post(endpoint + '/quiz/' + payload.quiz_id + '/items', formData)
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },

    getUserClassroom: (uuid) => Api.get(endpoint + '/user/' + uuid + '?per_page=100'),
    assignUserClassroom: (payload) => Api.post(endpoint + '/assign/user', payload),
    getAllCertificate: (perPage, page, search) => {
        let endpoint = endpointV3 + '/certificate?per_page=' + perPage + '&page=' + page
        if (search) {
            endpoint = endpoint + '&search=' + search
        }
        const res = Api.get(endpoint)
        return Promise.resolve(res)
    },
    getUserCertificate: (uuid) => Api.get(endpointV2 + '/certificate?search=' + uuid + '&per_page=100'),
    showCertificate: (code) => Api.get(endpoint + '/certificate/' + code + '/show'),
    downloadCertificate: (code, uuid) => Api.get(endpoint + '/certificate/' + code + '/show?uuid=' + uuid),
    getAllOldCertificate: (perPage, page, search) => {
        let url = endpoint + '/old-certificate?per_page=' + perPage + '&page=' + page + '&order=[id:asc]'
        if (search) {
            url = url + '&search=[name:' + search + '],[file:' + search + '],[classroom:' + search + ']'
        }
        const res = Api.get(url)
        return Promise.resolve(res)
    },
    // mentor
    mentorAdd: (code, payload) => {
        const res = Api.post(endpoint + '/level/' + code + '/mentor', {
            "uuid": payload
        }, {
            timeout: defaultTime
        })

        return Promise.resolve(res)
    },
    mentorDelete: (code, uuid) => {
        const res = Api.delete(endpoint + '/level/' + code + '/mentor/' + uuid, {
            timeout: defaultTime
        })

        return Promise.resolve(res)
    },
    // webinar record
    webinarRecordList: id => Api.get(endpoint + '/classroom/' + id + '/webinar-record'),
    webinarRecordDetail: webinarRecordId => Api.get(endpoint + '/webinar-record/' + webinarRecordId),
    webinarRecordAdd: (payload) => {
        const res = Api.post(endpoint + '/webinar-record', payload, {
            timeout: defaultTime
        })
        return Promise.resolve(res)
    },
    webinarRecordEdit: (webinarRecordId, payload) => {
        const res = Api.put(endpoint + '/webinar-record/' + webinarRecordId, payload, {
            timeout: defaultTime
        })
        return Promise.resolve(res)
    },
    webinarRecordDelete: (webinarRecordId) => {
        const res = Api.delete(endpoint + '/webinar-record/' + webinarRecordId, {
            timeout: defaultTime
        })
        return Promise.resolve(res)
    },
    classroomFreeList: () => {
        const res = Api.get(endpoint + '/free', {
            timeout: defaultTime
        })
        return Promise.resolve(res)
    },
    classroomFreeDetail: (id) => {
        const res = Api.get(endpoint + '/free/' + id, {
            timeout: defaultTime
        })
        return Promise.resolve(res)
    },
    classroomFreeAdd: (data) => {
        const payload = {
            classroom_id: data.classroom.id,
            started_at: data.startedAt,
            expired_at: data.expiredAt,
        }
        const res = Api.post(endpoint + '/free/', payload, {
            timeout: defaultTime
        })
        return Promise.resolve(res)
    },
    classroomFreeUpdate: (classroomFreeId, data) => {
        const payload = {
            classroom_id: data.classroom.id,
            started_at: data.startedAt,
            expired_at: data.expiredAt,
        }
        const res = Api.put(endpoint + '/free/' + classroomFreeId, payload, {
            timeout: defaultTime
        })
        return Promise.resolve(res)
    },
    classroomFreeDelete: (classroomFreeId) => {
        const res = Api.delete(endpoint + '/free/' + classroomFreeId, {
            timeout: defaultTime
        })
        return Promise.resolve(res)
    },
    openCertificate: (code) => {
        Api.get(endpoint + '/certificate/' + code + '/show')
    },

    //Webinar Quiz
    webinarQuizList: () => {
        try {
            const res = Api.get(endpoint + '/admin-webinar-quiz')
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },
    webinarQuizListFilter: (id) => {
        try {
            const res = Api.get(endpoint + '/admin-webinar-quiz?webinar_id=' + id)
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },
    webinarQuizDetail: (id) => {
        try {
            const res = Api.get(endpoint + '/admin-webinar-quiz/' + id)
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },
    webinarQuizAdd: (data) => {
        try {
            const payload = {
                name: data.name,
                slug: data.slug,
                description: data.description,
                short_description: data.shortDescription,
                ordering: data.ordering,
                display: data.display,
                quiz_type: data.quizType,
                started_at: data.startedAt,
                ended_at: data.endedAt,
                webinar_id: data.webinarId,
                is_active: data.isActive,
                is_randomized: data.isRandomized
            }

            const res = Api.post(endpoint + '/admin-webinar-quiz/', payload)
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },
    webinarQuizEdit: (id, data) => {
        try {
            const payload = {
                name: data.name,
                slug: data.slug,
                description: data.description,
                short_description: data.shortDescription,
                ordering: data.ordering,
                display: data.display,
                quiz_type: data.quizType,
                started_at: data.startedAt,
                ended_at: data.endedAt,
                webinar_id: data.webinarId,
                is_active: data.isActive,
                is_randomized: data.isRandomized
            }

            const res = Api.put(endpoint + '/admin-webinar-quiz/' + id, payload)
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },
    webinarQuizDelete: (id) => {
        try {
            const res = Api.delete(endpoint + '/admin-webinar-quiz/' + id, {
                timeout: defaultTime
            })
            return Promise.resolve(res);
        } catch (err) {
            return Promise.reject(err)
        }
    },
    webinarQuizItemList: () => {
        try {
            const res = Api.get(endpoint + '/webinar-quiz-item')
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },
    webinarQuizItemListFilter: (id) => {
        try {
            const res = Api.get(endpoint + '/webinar-quiz-item?webinar_quiz_id=' + id)
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },
    webinarQuizItemDetail: (id) => {
        try {
            const res = Api.get(endpoint + '/webinar-quiz-item/' + id)
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },
    webinarQuizItemAdd: (data) => {
        try {
            const payload = {
                question: data.question,
                choices: data.choices,
                answer: data.answer,
                point: data.point,
                webinar_quiz_id: data.webinarQuizId,
                ordering: data.ordering
            }
            const res = Api.post(endpoint + '/webinar-quiz-item', payload)
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },
    webinarQuizItemEdit: (id, data) => {
        try {
            const payload = {
                question: data.question,
                choices: data.choices,
                answer: data.answer,
                point: data.point,
                webinar_quiz_id: data.webinarQuizId,
                ordering: data.ordering
            }
            const res = Api.put(endpoint + '/webinar-quiz-item/' + id, payload)
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },
    webinarQuizItemDelete: (id) => {
        try {
            const res = Api.delete(endpoint + '/webinar-quiz-item/' + id, {
                timeout: defaultTime
            })
            return Promise.resolve(res);
        } catch (err) {
            return Promise.reject(err)
        }
    },
    webinarQuizItemImport: (payload) => {
        try {
            const formData = new FormData()
            formData.append('file', payload.file)
            const res = Api.post(endpoint + '/admin-webinar-quiz/' + payload.id + '/items', formData)
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },
    //mentor data
    mentorDataAdd: (payload) => {
        try {
            const formData = new FormData()
            formData.append('classroom_id', payload.classroomId)
            formData.append('name', payload.name)
            formData.append('attribution', payload.attribution)
            formData.append('photo', payload.photo)
            if (payload.description) {
                formData.append('description', payload.description)
            }

            const res = Api.post(endpoint + '/mentor-data', formData)
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },
    mentorDataUpdate: (id, payload) => {
        // console.log(payload)
        try {
            const formData = new FormData()
            formData.append('classroom_id', payload.classroomId)
            formData.append('name', payload.name)
            formData.append('attribution', payload.attribution)
            formData.append('photo', payload.photo)
            if (payload.description) {
                formData.append('description', payload.description)
            }

            const res = Api.put(endpoint + '/mentor-data/' + id, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                timeout: defaultTime
            })
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },
    reviewList: (id) => {
        try {
            const res = Api.get(endpointPublic + '/classroom/' + id + '/review')
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },


    reviewDetail: (idClassroom, idReview) => {
        try {
            const res = Api.get(endpoint + '/classroom/' + idClassroom + '/review/' + idReview)
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },
    reviewAdd: (id, payload) => {
        try {
            const res = Api.post(endpoint + '/classroom/' + id + '/review', payload)
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },
    reviewUpdate: (id, payload) => {
        try {
            const data = {
                rating: payload.rating,
                content: payload.content
            }
            const res = Api.put(endpoint + '/classroom/' + id + '/review/' + payload.id, data)
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },
    reviewRemove: (idClassroom, idReview) => {
        try {
            const res = Api.delete(endpoint + '/classroom/' + idClassroom + '/review/' + idReview, {
                timeout: defaultTime
            })
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },
    taskList: (id) => {
        try {
            const res = Api.get(endpoint + '/level/' + id + '/task')
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },
    taskDetail: (id) => {
        try {
            const res = Api.get(endpoint + '/task/' + id)
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },
    taskAdd: (levelId, payload) => {
        try {
            const res = Api.post(endpoint + '/level/' + levelId + '/task', payload)
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },
    taskUpdate: (taskId, payload) => {
        try {
            const res = Api.put(endpoint + '/task/' + taskId, payload)
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },
    taskRemove: (taskId) => {
        try {
            const res = Api.delete(endpoint + '/task/' + taskId)
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },
    lockClassroom: (id) => {
        try {
            const res = Api.put(endpoint + '/user-classroom/' + id + '/set-lock')
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },
    // Recommendation
    getListRecommendation: (classroomId) => {
        try {
            const res = Api.get(endpoint + '/recommendation/' + classroomId)
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },
    recommendationAdd: (classroomId, payload) => {
        try {
            // console.log('payload', payload)
            const form = {
                    classrooms: [
                        payload
                    ]
                }
                // console.log('formed', form)
            const res = Api.post(endpoint + '/recommendation/' + classroomId, form)
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },
    recommendationUpdate: (classroomId, payload, updateClassroom) => {

        try {

            let form

            if (updateClassroom) {

                form = {

                    classroom_id: payload.id,
                    price: payload.price

                }
            } else {
                form = {
                    name: payload.name,
                    description: payload.description
                }
            }

            const res = Api.put(endpoint + '/recommendation/' + classroomId, form)
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },
    recommendationDelete: (classroomId, payload) => {
        try {
            const res = Api.post(endpoint + '/recommendation/' + classroomId + '/delete', payload)
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },

    // hot class
    getListHot: () => {
        try {
            const res = Api.get(endpointPublic + '/tag/hot/')
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },
    hotAdd: (payload) => {
        try {
            // console.log('payload', payload)
            const form = {
                    items: [
                        payload
                    ]
                }
                // console.log('formed', form)
            const res = Api.post(endpoint + '/tag/hot', form)
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },

    hotDelete: (id) => {
        try {
            const form = {
                items: [
                    id
                ]
            }
            const res = Api.post(endpoint + '/tag/hot/delete', form)
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },

    // get admin webinar alll
    getAdminWebinar(start, end) {
        try {
            const res = Api.get(endpoint +
                '/admin/webinar?started_at=' +
                start +
                '&finished_at=' +
                end)
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }

    }, 

    getPreTest(id) {
        try {
            const res = Api.get(endpoint +
                '/classroom/' + 
                id +
                '/pre-test/all')
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },

    addPreTest(payload) {
        try {
            const res = Api.post(endpoint +
                '/pre-test/', payload)
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },

    updatePreTest(id, payload) {
        try {
            const res = Api.put(endpoint +
                '/pre-test/' +
                id , payload)
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },

    deletePreTest(id) {
        try {
            const res = Api.delete(endpoint +
                '/pre-test/' +
                id)
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },

    getPostTest(id) {
        try {
            const res = Api.get(endpoint +
                '/classroom/' + 
                id +
                '/post-test/all')
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },

    addPostTest(payload) {
        try {
            const res = Api.post(endpoint +
                '/post-test/', payload)
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },

    updatePostTest(id, payload) {
        try {
            const res = Api.put(endpoint +
                '/post-test/' +
                id , payload)
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },

    deletePostTest(id) {
        try {
            const res = Api.delete(endpoint +
                '/post-test/' +
                id)
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },

    addPrePostTestItem(payload, type) {
        try {
            if (type) {
                const res = Api.post(endpoint +
                    '/post-test-item/', payload)
                return Promise.resolve(res)
            } else {
                const res = Api.post(endpoint +
                    '/pre-test-item/', payload)
                return Promise.resolve(res)
            }
        } catch (err) {
            return Promise.reject(err)
        }
    },

    updatePrePostTestItem(id, payload, type) {
        try {
            if(type) {
                const res = Api.put(endpoint + 
                    '/post-test-item/' + 
                    id, payload)
                return Promise.resolve(res)
            } else {
                const res = Api.put(endpoint + 
                    '/pre-test-item/' + 
                    id, payload)
                return Promise.resolve(res)
            }
        } catch (err) {
            return Promise.reject(err)
        }
    },

    deletePrePostTestItem(id, type) {
        try {
            if(type) {
                const res = Api.delete(endpoint +
                    '/post-test-item/' + id)
                return Promise.resolve(res)
            } else {
                const res = Api.delete(endpoint +
                    '/pre-test-item/' + id)
                return Promise.resolve(res)
            }
        } catch (err) {
            return Promise.reject(err)
        }
    },

    importPrePostTest: (payload, type) => {
        try {
            if (type) {
                const formData = new FormData()
                formData.append('file', payload.file)
                const res = Api.post(endpoint + '/post-test/' + payload.id + '/items', formData)
                return Promise.resolve(res)
            } else {
                const formData = new FormData()
                formData.append('file', payload.file)
                const res = Api.post(endpoint + '/pre-test/' + payload.id + '/items', formData)
                return Promise.resolve(res)
            }
        } catch (err) {
            return Promise.reject(err)
        }
    },

    getAllRooms(perPage, page) {
        try {
            const res = Api.get(endpoint + 
                '/room-webinar?per_page=' +
                perPage + 
                '&page=' + 
                page)
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },

    getOneRoom(id) {
        try {
            const res = Api.get(endpoint +
                '/room-webinar/' +
                id)
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },

    addRoom(payload) {
        try {
            const res = Api.post(endpoint + 
                '/room-webinar', payload)
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },

    updateRoom(id, payload) {
        try {
            const res = Api.put(endpoint + 
                '/room-webinar/' + 
                id, payload)
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },

    deleteRoom(id) {
        try {
            const res = Api.delete(endpoint +
                '/room-webinar/' +
                id)
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },

    getAllWebinarRequested(perPage, page) {
        try {
            const res = Api.get(endpoint +
                '/admin/webinar-request/requested?per_page' +
                perPage + 
                '&page=' + 
                page)
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },

    getUserRequestWebinar(webinarId) {
        try {   
            const res = Api.get(endpoint + 
                '/mentor/webinar/' +
                webinarId +
                '/request')
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },

    getWebinarApprovedByMentor() {
        try {
            const res = Api.get(endpoint +
                '/admin/webinar-request/approved')
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },

    getAllRequestWebinarPlus() {
        try {
            const res = Api.get(endpoint + 
                '/admin/request-webinar')
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },

    addWebinarPlus(payload) {
        try {
            const res = Api.post(endpoint + 
                '/admin/request-webinar', payload)
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },

    updateWebinarPlus(id ,payload) {
        try {
            const res = Api.post(endpoint + 
                '/admin/request-webinar/' +
                id, payload)
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },

    deleteWebinarPlus(id) {
        try {
            const res = Api.delete(endpoint +
                '/admin/request-webinar/' +
                id)
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },

    getWebinarPrePostTest(perPage, page) {
        try {
            const res = Api.get(endpoint +
                '/pre-post-webinar?per_page=' + 
                perPage +
                '&page=' + 
                page)
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },

    regenerateGraduation(classCode, uuid) {
        try {
            const res = Api.get(endpoint +
                '/finish/graduation/' + 
                classCode + 
                '/' +
                uuid +
                '?regenerate=true')
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },

    regenerateCompletion(classCode, uuid) {
        try {
            const res = Api.get(endpoint +
                '/finish/completion/' + 
                classCode +
                '/' +
                uuid +
                '?regenerate=true')
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },

    getAllMaterials(classCode) {
        try {
            const res = Api.get(endpoint +
                '/classroom/' +
                classCode + 
                '/materials')
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },

    getOneMaterial(id) {
        try {
            const res = Api.get(endpoint +
                '/material/' +
                id)
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },

    addMaterial(classCode, payload) {
        try {
            const res = Api.post(endpoint +
                '/classroom/' +
                classCode + 
                '/materials', payload)
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },

    updateMaterial(id, payload) {
        try {
            const res = Api.put(endpoint +
                '/material/' +
                id, payload)
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },

    deleteMaterial(id) {
        try {
            const res = Api.delete(endpoint +
                '/material/' +
                id)
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },

    addMaterialItem(id, payload) {
        try {
            const res = Api.post(endpoint + 
                '/material/' +
                id +
                '/items', payload)
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },

    updateMaterialItem(id, payload) {
        try {
            const res = Api.put(endpoint +
                '/material-item/' +
                id, payload)
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },

    deleteMaterialItem(id) {
        try {
            const res = Api.delete(endpoint +
                '/material-item/' + 
                id)
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },

    createAssetVideo(id, payload) {
        try {
            const formData = new FormData
            formData.append('name', payload.name)
            formData.append('file', payload.file)
            const res = Api.post(endpoint +
                '/subject/' + 
                id +
                '/asset', formData)
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },

    deleteAssetVideo(id) {
        try {
            const res = Api.delete(endpoint +
                '/subject-asset/' + 
                id)
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },

    createAssetModule(id, payload) {
        try {
            const formData = new FormData
            formData.append('name', payload.name)
            formData.append('file', payload.file)
            const res = Api.post(endpoint +
                '/module/' + 
                id +
                '/asset', formData)
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },

    deleteResolutionVideo(id) {
        try {
            const res = Api.delete(endpoint +
                '/resolution/' +
                id)
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },

    getUserQuestion(classroomId, page, perPage) {
        try {
            const res = Api.get(endpoint + 
                '/mentor/classroom/' + 
                classroomId + 
                '/question?page=' + 
                page + 
                '&limit=' + 
                perPage)
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },

    getPrivateWebinar(filter) {
        try {
            const res = Api.get(endpoint +
                '/admin/webinar-private?filter='+
                filter)
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },

    setLinkPrivateWebinar(id, payload) {
        try {
            const res = Api.put(endpoint + 
                '/admin/webinar-private/' +
                id + '/set-link', payload)
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },

    getClassroomReview(code, page, perPage) {
        try {
            const res = Api.get(endpointV2 + 
                '/classroom/' + 
                code + 
                '/review?page=' +
                page +
                '&per_page=' + 
                perPage)
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },

    downloadMember(code) {
        try {
            const res = Api.get(endpoint + '/classroom/' + code + '/download', { responseType: 'blob' })
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },

    graduateMemberFromClassroom(payload) {
        try {
            const res = Api.post(endpoint + '/graduate', payload)
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },
});